import { Befehl } from '../models'
import { hasEmptyWerte, hasEmptyStringFields } from './helpers'

/**
 * Checks if a Befehl has any empty fields.
 *
 * Returns true when:
 * - ANY field exists but has empty values
 *
 * Returns false when:
 * - No befehl exists
 * - No aufträge exist
 * - No felder exist
 * - All felder have complete content
 *
 * @returns true if has any empty fields, false otherwise
 */
export function hasBefehlGenericEmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  for (const auftrag of befehl.auftraege) {
    if (!auftrag?.felder || auftrag.felder.length === 0) {
      continue
    }

    for (const feld of auftrag.felder) {
      if (!feld?.werte) {
        return true
      }

      if (hasEmptyWerte(feld)) {
        continue
      }

      if (hasEmptyStringFields(feld.werte)) {
        return true
      }
    }
  }

  return false
}
